import React from "react";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
    AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

// A button that asks before acting (dark, in-app dialog instead of window.confirm).
export default function ConfirmAction({ title, description, confirmLabel, onConfirm, testid, disabled, className, children }) {
    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <button disabled={disabled} className={className} data-testid={testid}>{children}</button>
            </AlertDialogTrigger>
            <AlertDialogContent className="bg-[#0a0a0a] border-white/15 text-white" data-testid={`${testid}-dialog`}>
                <AlertDialogHeader>
                    <AlertDialogTitle className="font-display tracking-tight">{title}</AlertDialogTitle>
                    <AlertDialogDescription className="text-white/60">{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel className="bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white" data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm} className="bg-white text-black hover:bg-white/90" data-testid={`${testid}-confirm`}>{confirmLabel}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
